<template>
<div class="modal-mask-pause background-melody">
    <div class="modal-wrapper-pause">
        <div class="modal-container-pause">

            <div class="modal-header-pause tamanhotitle">
                <slot name="header">
                     {{$t('games.melody.waiting')}}
                </slot>
            </div>
            <div class="modal-body-wait">
                <slot name="body">
                    <div class="containerwatin-melody">
                      <div class="dash uno"></div>
                      <div class="dash dos"></div>
                      <div class="dash tres"></div>
                      <div class="dash cuatro"></div>
                    </div>
                </slot>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "WaitModal",
    created() {},
    data() {
        return {};
    },
    props: {},
    methods: {},
};
</script>

<style>

.modal-body-wait {
    margin-top: 3em;
    margin-bottom:2em;
    display: flex;
    align-self: center;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from,
.modal-leave-to {
    opacity: 0;
}

.modal-enter-active .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.containerwatin-melody {
  display: flex;
}

.dash {
  margin: 0 15px;
  width: 35px;
  height: 15px;
  border-radius: 8px;
  border: solid black;
}

.uno {
  margin-right: -18px;
  transform-origin: center left;
  animation: spin 3s linear infinite;
}

.dos {
  transform-origin: center right;
  animation: spin2 3s linear infinite;
  animation-delay: .2s;
}

.tres {
  transform-origin: center right;
  animation: spin3 3s linear infinite;
  animation-delay: .3s;
}

.cuatro {
  transform-origin: center right;
  animation: spin4 3s linear infinite;
  animation-delay: .4s;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(360deg);
  }
  30% {
    transform: rotate(370deg);
  }
  35% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spin2 {
  0% {
    transform: rotate(0deg);
  }
  20% {
    transform: rotate(0deg);
  }
  30% {
    transform: rotate(-180deg);
  }
  35% {
    transform: rotate(-190deg);
  }
  40% {
    transform: rotate(-180deg);
  }
  78% {
    transform: rotate(-180deg);
  }
  95% {
    transform: rotate(-360deg);
  }
  98% {
    transform: rotate(-370deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

@keyframes spin3 {
  0% {
    transform: rotate(0deg);
  }
  27% {
    transform: rotate(0deg);
  }
  40% {
    transform: rotate(180deg);
  }
  45% {
    transform: rotate(190deg);
  }
  50% {
    transform: rotate(180deg);
  }
  62% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(360deg);
  }
  80% {
    transform: rotate(370deg);
  }
  85% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spin4 {
  0% {
    transform: rotate(0deg);
  }
  38% {
    transform: rotate(0deg);
  }
  60% {
    transform: rotate(-360deg);
  }
  65% {
    transform: rotate(-370deg);
  }
  75% {
    transform: rotate(-360deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}


@media only screen and (max-width: 480px) {
  .modal-header-wait h1 {
    font-size: 1.2rem;
  }
  .dash {
    width: 25px;
    height: 5px;
  }
}
@media only screen and (min-width: 480px) and (max-width: 550px) {
  .modal-header-wait h1 {
    font-size: 1.4rem;
  }
  .dash {
    width: 27px;
    height: 7px;
  }
}
@media only screen and (min-width: 550px) and (max-width: 630px){
  .modal-header-wait h1 {
    font-size: 1.6rem;
  }
  .dash {
    width: 29px;
    height: 9px;
  }
}
@media only screen and (min-width: 630px) and (max-width: 718px){
  .modal-header-wait h1 {
    font-size: 1.8rem;
  }
  .dash {
    width: 31px;
    height: 11px;
  }
}
@media only screen and (min-width: 718px) and (max-width: 806px) {
  .modal-header-wait h1 {
    font-size: 2rem;
  }
  .dash {
    width: 33px;
    height: 13px;
  }
}
@media only screen and (min-width: 806px) and (max-width: 1024px) {
  .modal-header-wait h1 {
    font-size: 2.2rem;
  }
  .dash {
    width: 35px;
    height: 15px;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1200px) {
  .modal-header-wait h1 {
    font-size: 2.4rem;
  }
  .dash {
    width: 37px;
    height: 17px;
    border-radius: 8px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1366px) {
  .modal-header-wait h1 {
    font-size: 2.6rem;
  }
  .dash {
    width: 39px;
    height: 19px;
    border-radius: 8px;
  }
}
@media only screen and (min-width: 1366px) and (max-width: 1540px){
  .modal-header-wait h1 {
    font-size: 2.8rem;
  }
  .dash {
    width: 41px;
    height: 21px;
    border-radius: 8px;
  }
}
@media only screen and (min-width: 1540px) and (max-width: 1680px){
  .modal-header-wait h1 {
    font-size: 3rem;
  }
  .dash {
    width: 43px;
    height: 23px;
    border-radius: 8px;
  }
}
@media only screen and (min-width: 1680px) and (max-width:2350px){
  .modal-header-wait h1 {
    font-size: 3.2rem;
  }
  .dash {
    width: 45px;
    height: 25px;
    border-radius: 10px;
  }
}
@media only screen and (min-width: 2350px) {
  .modal-header-wait h1 {
    font-size: 3.4rem;
  }
  .dash {
    width: 51px;
    height: 31px;
    border-radius: 12px;
  }
}

</style>
